import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// FastAPI store: GET /api/v1/store/catalog/categories → { categorys: [...] }
export const get_category = createAsyncThunk(
    'product/get_category',
    async(_, { fulfillWithValue }) => {
        try {
            const { data } = await api.get('/catalog/categories')
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/catalog/products → { products, latest_product, topRated_product, discount_product }
export const get_products = createAsyncThunk(
    'product/get_products',
    async(_, { fulfillWithValue }) => {
        try {
            const { data } = await api.get('/catalog/products')
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/catalog/price-range → { latest_product, priceRange }
export const price_range_product = createAsyncThunk(
    'product/price_range_product',
    async(_, { fulfillWithValue }) => {
        try {
            const { data } = await api.get('/catalog/price-range')
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/catalog/query?category=&rating=&lowPrice=&highPrice=&sortPrice=&pageNumber=&searchValue=
export const query_products = createAsyncThunk(
    'product/query_products',
    async(query, { fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/catalog/query?category=${query.category}&rating=${query.rating}&lowPrice=${query.low}&highPrice=${query.high}&sortPrice=${query.sortPrice}&pageNumber=${query.pageNumber}&searchValue=${query.searchValue || ''}`
            )
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/catalog/product/{slug}
export const product_details = createAsyncThunk(
    'product/product_details',
    async(slug, { fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/catalog/product/${slug}`)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: POST /api/v1/store/reviews/submit
export const customer_review = createAsyncThunk(
    'review/customer_review',
    async(info, { fulfillWithValue }) => {
        try {
            const { data } = await api.post('/reviews/submit', info)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/reviews/{productId}?pageNo=
export const get_reviews = createAsyncThunk(
    'review/get_reviews',
    async({ productId, pageNumber }, { fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/reviews/${productId}?pageNo=${pageNumber}`)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// FastAPI store: GET /api/v1/store/banners
export const get_banners = createAsyncThunk(
    'banner/get_banners',
    async(_, { fulfillWithValue }) => {
        try {
            const { data } = await api.get('/banners')
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

// Qué métodos de pago acepta la tienda. Lo decide el admin y la tienda lo
// obedece: ofrecer un pago que no se puede cobrar es peor que no ofrecerlo.
export const get_store_config = createAsyncThunk(
    'home/get_store_config',
    async(_, { fulfillWithValue }) => {
        try {
            const { data } = await api.get('/config')
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
        }
    }
)

export const homeReducer = createSlice({
    name: 'home',
    initialState: {
        categorys: [],
        products: [],
        totalProduct: 0,
        parPage: 12,
        latest_product: [],
        topRated_product: [],
        discount_product: [],
        priceRange: { low: 0, high: 100 },
        product: {},
        relatedProducts: [],
        moreProducts: [],
        errorMessage: '',
        successMessage: '',
        totalReview: 0,
        rating_review: [],
        reviews: [],
        banners: [],
        // Hasta que el servidor conteste no se sabe qué se acepta, así que no
        // se asume nada: la pantalla muestra que está cargando.
        metodosPago: null,
        codMontoMaximo: null,
        codZonasExcluidas: [],
        departamentos: [],
        // Los municipios de cada departamento, para que el checkout no los
        // pida como texto libre.
        municipios: {},
        // Política de envío: qué departamentos tienen reparto propio y cuánto
        // cuesta. Al resto, el envío lo paga el cliente a la mensajería.
        envio: null,
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(get_category.fulfilled, (state, { payload }) => {
            state.categorys = payload?.categorys || []
        })

        .addCase(get_products.fulfilled, (state, { payload }) => {
            state.products         = payload?.products         || []
            state.latest_product   = payload?.latest_product   || []
            state.topRated_product = payload?.topRated_product || []
            state.discount_product = payload?.discount_product || []
        })

        .addCase(price_range_product.fulfilled, (state, { payload }) => {
            state.latest_product = payload?.latest_product || []
            state.priceRange     = payload?.priceRange     || { low: 0, high: 100 }
        })

        .addCase(query_products.fulfilled, (state, { payload }) => {
            state.products     = payload?.products     || []
            state.totalProduct = payload?.totalProduct || 0
            state.parPage      = payload?.parPage      || 12
        })

        .addCase(product_details.fulfilled, (state, { payload }) => {
            state.product         = payload?.product         || {}
            state.relatedProducts = payload?.relatedProducts || []
            state.moreProducts    = payload?.moreProducts    || []
        })

        .addCase(customer_review.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || ''
        })

        .addCase(get_reviews.fulfilled, (state, { payload }) => {
            state.reviews      = payload?.reviews      || []
            state.totalReview  = payload?.totalReview  || 0
            state.rating_review = payload?.rating_review || []
        })

        .addCase(get_banners.fulfilled, (state, { payload }) => {
            state.banners = payload?.banners || []
        })

        .addCase(get_store_config.fulfilled, (state, { payload }) => {
            state.metodosPago = payload?.metodos_pago || []
            state.codMontoMaximo = payload?.cod_monto_maximo ?? null
            state.codZonasExcluidas = payload?.cod_zonas_excluidas || []
            state.departamentos = payload?.departamentos || []
            state.municipios = payload?.municipios || {}
            state.envio = payload?.envio || null
        })
    }
})

export const { messageClear } = homeReducer.actions
export default homeReducer.reducer
